import * as React from "react";
import { useDispatch } from "react-redux";
import { logout } from "app/LineDetails/actions";
import InvLoader from "./../../assets/icons/global-icon-loading.svg";
import "./index.scss";

export default function Logout() {
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(logout());
  }, []);

  return (
    <React.Fragment>
      <div className="invLoader">
        <span>
          {" "}
          <img src={InvLoader} alt={"InvLoader"} width="24px" height="24px" />
        </span>
        Logging out...{" "}
      </div>
    </React.Fragment>
  );
}
